import React from 'react'
import * as microConfig from '@/views/micro/config'
import useGlobalThemeStore from '@/store/globalTheme'

/** @jsxRuntime classic */
/** @jsx jsxCustomEvent */
import jsxCustomEvent from '@micro-zoe/micro-app/polyfill/jsx-custom-event' // 必须声明，micro内部在使用jsxCustomEvent

const UserManage: React.FC = () => {
  const { colorPrimary } = useGlobalThemeStore()
  return (
    <>
      <micro-app
        name={microConfig.MICRO_APPS[0].name}
        url={microConfig.MICRO_APPS[0].url}
        defaultPage={microConfig.BASE_ROUTE.userList}
        data={{
          theme: {
            colorPrimary
          }
        }}
      />
    </>
  )
}

export default UserManage
